<template>
  <!--  用户管理 -->
  <div>
    <!-- 顶部搜索 -->
    <el-form size="small"
             :inline="true"
             label-width="108px">
      <el-form-item label="手机号/姓名"
                    prop="keyword">
        <el-input v-model="queryParams.keyword"
                  placeholder="请输入手机号或姓名"
                  @keyup.enter.native="inquire"
                  clearable></el-input>
      </el-form-item>

      <el-form-item label="销售姓名"
                    prop="sellerName">
        <el-input v-model="queryParams.seller"
                  placeholder="请输入销售姓名"
                  @keyup.enter.native="inquire"
                  clearable></el-input>
      </el-form-item>
      <el-form-item label="用户来源">
        <el-select v-model="queryParams.source"
                   placeholder="请选择用户来源"
                   clearable>
          <el-option label="销售端"
                     value="1"></el-option>
          <el-option label="产品端"
                     value="2"></el-option>
          <el-option label="线下"
                     value="3"></el-option>
          <el-option label="手动添加"
                     value="6"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="体检报告状态">
        <el-select v-model="queryParams.status"
                   placeholder="请选择体检报告状态"
                   clearable>
          <el-option label="待审核"
                     value="0"></el-option>
          <el-option label="审核不通过"
                     value="1"></el-option>
          <el-option label="审核通过"
                     value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="认证状态">
        <el-select v-model="queryParams.auditStatus"
                   placeholder="请选择认证状态"
                   clearable>
          <el-option label="待审核"
                     value="0"></el-option>
          <el-option label="审核不通过"
                     value="1"></el-option>
          <el-option label="审核通过"
                     value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   size="medium"
                   icon="el-icon-search"
                   @click="inquire">搜索</el-button>
      </el-form-item>
      <el-form-item>
         <el-button type="primary"
                   size="medium"
                   icon="el-icon-bottom"
                   @click="exportUser">导出用户信息</el-button>
      </el-form-item>
    </el-form>
    <el-card class="box-card">
      <!-- (CURD)操作按钮 -->
      <!-- 表格区域 -->
      <el-table :data="userList"
                align="center"
                style="width: 100%"
                :header-cell-style="{background: '#f8f8f9'}">
        <el-table-column prop="phone"
                         align="center"
                         label="手机">
          <template slot-scope="scope">
            <el-link type="primary"
                     :underline="false"
                     @click.native="goto(scope.row.phone)">{{scope.row.phone}}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="name"
                         align="center"
                         label="姓名">

        </el-table-column>
        <el-table-column prop="age"
                         width="50"
                         align="center"
                         label="年龄">
        </el-table-column>
        <el-table-column prop="gender"
                         width="50"
                         align="center"
                         label="性别"
                         :formatter="sex">
        </el-table-column>
        <el-table-column prop="sellerName"
                         align="center"
                         label="销售">
        </el-table-column>

        <el-table-column prop="source"
                         align="center"
                         label="来源">
          <template slot-scope="scope">
            <span v-show="scope.row.source==1">销售端</span>
            <span v-show="scope.row.source==2">产品端</span>
            <span v-show="scope.row.source==3">线下</span>
            <span v-show="scope.row.source==3">手动添加</span>

          </template>
        </el-table-column>
        <el-table-column prop="status"
                         align="center"
                         label="状态">
          <template slot-scope="scope">
            <span v-if="authAttr<=1">
              <span v-if="scope.row.status==1">正常</span>
              <span v-if="scope.row.status==2">已锁定</span>

            </span>
            <span v-if="scope.row.status==0">未注册</span>
            <span v-if="scope.row.status==3">已注销</span>
            <el-switch v-if="scope.row.status!=3&&scope.row.status!=0&&authAttr>1"
                       v-model="scope.row.status"
                       active-color="#13ce66"
                       inactive-color="#ff4949"
                       :active-value="1"
                       :inactive-value="2"
                       active-text="正常"
                       inactive-text="锁定"
                       @change="updateBrandStatus(scope.row)"></el-switch>
          </template>

        </el-table-column>
        <el-table-column prop="createdTime"
                         show-overflow-tooltip
                         align="center"
                         label="注册时间">
        </el-table-column>
        <el-table-column prop="lastTime"
                         show-overflow-tooltip
                         align="center"
                         label="最近一次登录时间">
        </el-table-column>
         <el-table-column prop="time"
                         show-overflow-tooltip
                         align="center"
                         label="登录次数">
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot="{row}">
            <el-button-group>

              <el-button @click="changeAddDialogVisible(row.id,row.seller)"
                         type="text"
                         size="mini"
                         icon="el-icon-edit"
                         v-if="row.status!=3&&row.status!=0&&authAttr>1">修改销售</el-button>
              <el-button @click="gotoReport(row)" 
              v-if="row.reportStatus==1"
                         type="text"
                         size="mini"
                         :style="{color:row.auditResults=== 0 ? '#D1352D': '#409EFF'}"
                         icon="el-icon-view">查看体检报告</el-button>
              <el-button @click="gotoCert(row)"
                         v-if="row.auditStatus !== null && row.auditStatus !== undefined && row.auditStatus !== ''"
                         type="text"
                         size="mini"
                         :style="{color: Number(row.auditStatus) === 0 ? '#D1352D' : '#409EFF'}"
                         icon="el-icon-s-check">认证审核</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页导航 -->
      <template>
        <el-row class="pagination">
          <pagination v-show="total>0"
                      :total="total"
                      :page.sync="queryParams.pageNum"
                      :limit.sync="queryParams.pageSize"
                      @pagination="getUserList" />

        </el-row>
      </template>
    </el-card>

    <!-- 修改用户渠道对话框 -->
    <template>
      <el-dialog title="修改用户渠道"
                 :visible.sync="modifyingDialogVisible"
                 width="35%">
        <div class="demo-input-suffix">
          <el-form :model="channelList"
                   ref="channelList"
                   :rules="rules"
                   label-width="80px">
            <!-- :model="form" -->
            <el-form-item label="用户id">
              <el-input v-model="channelList.userId"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="销售名"
                          prop="sellerId">
              <template>
                <el-select v-model="channelList.sellerId"
                           placeholder="请输入销售名">
                  <el-option v-for="item in sellerList"
                             :key="item.id"
                             :label="item.username"
                             :value="item.id">
                  </el-option>
                </el-select>
              </template>
            </el-form-item>

          </el-form>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="modifyingDialogVisible = false">取 消</el-button>
          <el-button type="primary"
                     @click="submitHandler('channelList')">确 定</el-button>
        </span>
      </el-dialog>
    </template>
    <!-- 展示体检报告 -->
    <el-dialog
      title="用户体检报告"
      :visible.sync="reportDialogVisible"
      width="30%"
      :before-close="handleClose">
       <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="体检报告审核" name="first">
          <span class="result">审核结果：<span :style="{color: auditResults==0 ? '#FCC31F' : auditResults==1 ? '#D1352D' : '#409EFF'}">{{ auditResults==0 ? '审核中' : auditResults==1 ?  '审核不通过' :'审核通过' }}</span></span>
          <span class="images_title">图片展示</span>
          <div  style="display: flex; gap: 10px;">
            <el-image v-for="(url,index) in imageList"
            :key="index"
            style="width: 100px; height: 100px"
            :src="url"
            :preview-src-list="getImgList(index)"
            :fit="fit"></el-image>
          </div>
          <span class="images_title">pdf展示</span>
          <div>
            <a href="javascript:;" @click="downloadAndOpenPdf(pdf)">{{pdf.slice(pdf.indexOf("-")+1,pdf.length)}}</a>
          </div>
          <div class="report-footer">
            <el-button v-if="auditResults==0" @click="rejected()">审核不通过</el-button>
            <el-button v-if="auditResults==0" type="primary" @click="approved()">审核通过</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="以往报告展示" name="second">
          <el-timeline :reverse="reverse">
            <el-timeline-item
              v-for="(item, index) in history"
              :key="index"
              :timestamp="formatDate(item.created)">
              <div class="status_item" :style="{color: item.auditResults==0 ? '#FCC31F' : item.auditResults==1 ? '#D1352D' : '#409EFF'}"> {{item.auditResults==0 ? '审核中' : item.auditResults==1 ? '审核不通过' : '审核通过'}}</div>
              <div class="reason" v-if="item.reason!=null">原因：{{ item.reason }}</div>
              <div>
                 <div class="iconpdf">图片</div>
                 <el-image v-for="(url,index1) in item.images"
                  :key="index1"
                  style="width: 100px; height: 100px"
                  :src="$url+url"
                  :preview-src-list="getImgList(index1)"
                  :fit="fit"></el-image>
              </div>
              <div>
                <span class="iconpdf">pdf：</span>
                <a href="javascript:;" @click="downloadAndOpenPdf(item.pdf)">{{item.pdf.slice(item.pdf.indexOf("-")+1,item.pdf.length)}}</a>
              </div>
               <el-divider></el-divider>
            </el-timeline-item>
          </el-timeline>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!-- 展示认证审核 -->
    <el-dialog
      title="用户认证审核"
      :visible.sync="certDialogVisible"
      width="50%"
      :before-close="handleCertClose">
       <el-tabs v-model="certActiveName">
        <el-tab-pane label="认证审核" name="first">
          <span class="result">审核结果：<span :style="{color: certAuditStatus==0 ? '#FCC31F' : certAuditStatus==1 ? '#D1352D' : '#409EFF'}">{{ certAuditStatus==0 ? '审核中' : certAuditStatus==1 ?  '审核不通过' :'审核通过' }}</span></span>
          <el-descriptions :column="2" border size="small" class="cert-desc">
            <el-descriptions-item label="姓名">{{ certInfo.name }}</el-descriptions-item>
            <el-descriptions-item label="手机号">{{ certInfo.phone }}</el-descriptions-item>
            <el-descriptions-item label="身份证号">{{ certInfo.idCard }}</el-descriptions-item>
            <el-descriptions-item label="上级推荐码">{{ certInfo.recommendCode }}</el-descriptions-item>
            <el-descriptions-item label="医院全称">{{ certInfo.hospital }}</el-descriptions-item>
            <el-descriptions-item label="科室">{{ certInfo.department }}</el-descriptions-item>
            <el-descriptions-item label="科室其他">{{ certInfo.departmentOther }}</el-descriptions-item>
            <el-descriptions-item label="备注">{{ certInfo.remark }}</el-descriptions-item>
            <el-descriptions-item label="审核人">{{ certInfo.auditor }}</el-descriptions-item>
            <el-descriptions-item label="不通过原因" :span="2" v-if="certAuditStatus==1">{{ certInfo.auditReason }}</el-descriptions-item>
          </el-descriptions>
          <span class="images_title">护士执业证图片</span>
          <div style="display: flex; gap: 10px; flex-wrap: wrap;">
            <div v-for="(url,index) in certLicenseImages"
                 :key="'license-'+index"
                 class="cert-preview-image"
                 @click="previewCertImages(certLicenseImages, index)">
              <el-image
                style="width: 100px; height: 100px"
                :src="url"
                :fit="fit">
              </el-image>
            </div>
            <span v-if="!certLicenseImages.length">暂无图片</span>
          </div>
          <span class="images_title">工作证明图片</span>
          <div style="display: flex; gap: 10px; flex-wrap: wrap;">
            <div v-for="(url,index) in certWorkImages"
                 :key="'work-'+index"
                 class="cert-preview-image"
                 @click="previewCertImages(certWorkImages, index)">
              <el-image
                style="width: 100px; height: 100px"
                :src="url"
                :fit="fit">
              </el-image>
            </div>
            <span v-if="!certWorkImages.length">暂无图片</span>
          </div>
          <span class="images_title">身份证图片</span>
          <div style="display: flex; gap: 10px; flex-wrap: wrap;">
            <div v-if="certIdCardFront" class="cert-id-item cert-preview-image" @click="previewCertImages(certIdCardPreviewList, 0)">
              <el-image
                style="width: 100px; height: 100px"
                :src="certIdCardFront"
                :fit="fit">
              </el-image>
            </div>
            <div v-if="certIdCardBack" class="cert-id-item cert-preview-image" @click="previewCertImages(certIdCardPreviewList, certIdCardFront ? 1 : 0)">
              <el-image
                style="width: 100px; height: 100px"
                :src="certIdCardBack"
                :fit="fit">
              </el-image>
            </div>
            <span v-if="!certIdCardFront && !certIdCardBack">暂无图片</span>
          </div>
          <div class="report-footer">
            <el-button v-if="certAuditStatus==0" @click="rejectedCert()">审核不通过</el-button>
            <el-button v-if="certAuditStatus==0" type="primary" @click="approvedCert()">审核通过</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!-- 认证图片放大预览 -->
    <el-dialog
      :visible.sync="certPreviewVisible"
      append-to-body
      width="70%"
      title="图片预览"
      custom-class="cert-img-preview-dialog">
      <div class="cert-img-preview-wrap">
        <img v-if="certPreviewList[certPreviewIndex]" :src="certPreviewList[certPreviewIndex]" class="cert-img-preview" />
        <div v-if="certPreviewList.length > 1" class="cert-img-preview-nav">
          <el-button size="mini" @click="certPreviewPrev">上一张</el-button>
          <span>{{ certPreviewIndex + 1 }} / {{ certPreviewList.length }}</span>
          <el-button size="mini" @click="certPreviewNext">下一张</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 拒绝报告框 -->
    <el-dialog
      title="请输入拒绝原因"
      :visible.sync="outerVisible"
      width="30%"
      >
      <el-input type="textarea" v-model="reason" placeholder="请输入拒绝原因"></el-input>
      <div class="reject_reason">
        <el-button @click="outerVisible = false">取 消</el-button>
        <el-button type="primary" @click="reportSubmit()">提交</el-button>
      </div>
        
    </el-dialog>
    <!-- 认证审核不通过原因 -->
    <el-dialog
      title="请输入拒绝原因"
      :visible.sync="certRejectVisible"
      width="30%"
      append-to-body
      >
      <el-input type="textarea" v-model="certReason" placeholder="请输入拒绝原因"></el-input>
      <div class="reject_reason">
        <el-button @click="certRejectVisible = false">取 消</el-button>
        <el-button type="primary" @click="certRejectSubmit()">提交</el-button>
      </div>
    </el-dialog>
    <!-- 审核积分 -->
    <el-dialog
      title="积分奖励"
      :visible.sync="funds"
      width="30%"
      >
      <el-input  v-model="fundsSize" placeholder="请输入用户获取积分多少"></el-input>
      <div class="reject_reason">
        <el-button @click="funds = false">取 消</el-button>
        <el-button type="primary" @click="fundsSubmit()">提交</el-button>
      </div>
        
    </el-dialog>
    
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination
  },
  data() {
    return {
      channelList: {
        userId: '',
        sellerId: ''
      },
      sellerList: [],
      id: '',
      name: '',
      userList: [],
      //获取用户列表传参
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        keyword: '',
        seller: '',
        source: '',
        status: '',
        auditStatus: ''
      },
      headers: {
        token: sessionStorage.getItem('token')
      },
      total: 0,
      // 控制修改渠道
      modifyingDialogVisible: false,
      reportDialogVisible: false,//体检报告展示框
      certDialogVisible: false,
      certRejectVisible: false,
      certActiveName: 'first',
      certUserId: '',
      certId: '',
      certAuditStatus: 0,
      certReason: '',
      certInfo: {},
      certLicenseImages: [],
      certWorkImages: [],
      certIdCardFront: '',
      certIdCardBack: '',
      certPreviewVisible: false,
      certPreviewList: [],
      certPreviewIndex: 0,
      fit: 'contain', // 图片预览适配模式
      images: [],
      imageList: [],
      pdf: '',
      adminId:'',
      auditResults:0,//审核是否通过
      activeName: 'first',
      reportImagesList: [],
      reportpdf: '',
      history:{
      },
      outerVisible: false,
      funds:false,
      fundsSize: '',
      reverse: false,
      reason:'',
      queryParams2: {
        pageNum: 1,
        pageSize: 100,
        type: 4
      },
      authAttr: '',
      rules: {
        sellerId: [{ required: true, message: '请选择销售名', trigger: 'change' }]
      },
      srcList: []
    }
  },
  created() {
    if (this.$route.query.pageNum != 1 && this.$route.query.pageNum != undefined) {
      this.queryParams.pageNum = Number(this.$route.query.pageNum)
    } else {
      this.queryParams.pageNum = 1
    }
  },
  mounted() {
    this.getUserList()
    this.getAuthAttr()
  },
  computed: {
    certIdCardPreviewList() {
      return [this.certIdCardFront, this.certIdCardBack].filter(Boolean)
    }
  },
  methods: {
    handleClick(tab, event){
      console.log(tab, event);
    },
    // 搜索按钮
    inquire() {
      this.queryParams.pageNum = 1
      this.getUserList()
    },
    // 导出用户信息
    async exportUser() {
      const { data: res } = await this.$http.post('/admin/user/exportAdminList', null, { responseType: 'arraybuffer' })
      const blob = new Blob([res])
      let a = document.createElement('a')
      a.style.display = 'none'
      a.download = `用户信息.xlsx`
      a.href = URL.createObjectURL(blob)
      document.body.appendChild(a)
      a.click()
    },
    getAuthAttr() {
      var authAttr = window.sessionStorage.getItem('auth-2')
      this.authAttr = authAttr
    },
    // 点击修改渠道名获取销售
    async changeAddDialogVisible(id, sellerId) {
      this.modifyingDialogVisible = true
      this.channelList.userId = id
      this.channelList.sellerId = sellerId
      const { data: res } = await this.$http.get('/admin/admin/getAdminList', { params: this.queryParams2 })
      this.sellerList = res.data.list
    },
    // 确认修改渠道按钮
    submitHandler(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const { data: res } = await this.$http.post(`/admin/user/updateUserSeller?id=${this.channelList.userId}&seller=${this.channelList.sellerId}`)
          if (res.code !== 200) return this.$message.error(res.msg)
          this.getUserList()
          this.modifyingDialogVisible = false
        }
      })
    },
    // 查看体检报告信息
    async  gotoReport(row){
      //（0.审核中  1.审核不通过 2.审核通过）
      if(row.auditResults==2){
        this.auditResults=2
      }else if(row.auditResults==0){
        this.auditResults=0
      }else if(row.auditResults==1){
        this.auditResults=1
      }
      this.adminId=row.id
      console.log(row)
      const {data:res} =await this.$http.get(`/admin/product/getUserReport?id=${row.id}`)
      console.log(res)
      if(res.code==200){
        if(res.data==null){
          this.$message.error('该用户暂无体检报告')
        }else{
          const imageStr = res.data.images
          if (imageStr) {
            this.imageList = imageStr
              .split(';')
              .filter(item => item != null && item != '')
              .map(item => this.$url + item.trim());
          }
          console.log(this.imageList)
          this.pdf=res.data.pdf
          this.reportDialogVisible = true
        }
      }
      console.log(row.id)
       const {data:result} =await this.$http.get(`/admin/physicalReportImages/getPhysicalList?userId=${row.id}`)
       this.history=result.data
       console.log("体检报告展示")
       console.log(this.history)
     
    },
    handleClose(){
      this.reportDialogVisible = false
    },
    handleCertClose(){
      this.certDialogVisible = false
    },
    pickCertField(data, ...keys) {
      if (!data) return ''
      for (let i = 0; i < keys.length; i++) {
        const val = data[keys[i]]
        if (val !== undefined && val !== null && val !== '') return val
      }
      return ''
    },
    parseCertImages(val) {
      if (!val) return []
      let list = []
      if (Array.isArray(val)) {
        list = val
      } else if (typeof val === 'string') {
        const str = val.trim()
        if (str.startsWith('[')) {
          try {
            list = JSON.parse(str)
          } catch (e) {
            list = str.split(/[;,]/)
          }
        } else {
          list = str.split(/[;,]/)
        }
      }
      return list
        .filter(item => item != null && String(item).trim() !== '')
        .map(item => {
          const path = String(item).trim()
          if (/^https?:\/\//.test(path)) return path
          return this.$url + path
        })
    },
    previewCertImages(list, index) {
      if (!list || !list.length) return
      this.certPreviewList = list
      this.certPreviewIndex = index || 0
      this.certPreviewVisible = true
    },
    certPreviewPrev() {
      if (!this.certPreviewList.length) return
      this.certPreviewIndex = (this.certPreviewIndex - 1 + this.certPreviewList.length) % this.certPreviewList.length
    },
    certPreviewNext() {
      if (!this.certPreviewList.length) return
      this.certPreviewIndex = (this.certPreviewIndex + 1) % this.certPreviewList.length
    },
    // 查看认证审核信息
    async gotoCert(row) {
      this.certUserId = row.id
      this.certActiveName = 'first'
      const { data: res } = await this.$http.get(`/admin/medicalCert/getByUserId?userId=${row.id}`)
      if (res.code != 200) return this.$message.error(res.msg || '获取认证信息失败')
      if (res.data == null) {
        this.$message.error('该用户暂无认证信息')
        return
      }
      const data = res.data
      this.certId = this.pickCertField(data, 'id')
      this.certInfo = {
        userId: this.pickCertField(data, 'userId', 'user_id'),
        name: this.pickCertField(data, 'name'),
        phone: this.pickCertField(data, 'phone'),
        idCard: this.pickCertField(data, 'idCard', 'id_card'),
        recommendCode: this.pickCertField(data, 'recommendCode', 'recommend_code'),
        hospital: this.pickCertField(data, 'hospital'),
        department: this.pickCertField(data, 'department'),
        departmentOther: this.pickCertField(data, 'departmentOther', 'department_other'),
        remark: this.pickCertField(data, 'remark'),
        auditor: this.pickCertField(data, 'auditorName', 'auditor_name', 'auditor', 'auditorId', 'auditor_id'),
        auditReason: this.pickCertField(data, 'auditReason', 'audit_reason'),
        auditedTime: this.pickCertField(data, 'auditedTime', 'audited_time'),
        integrationTime: this.pickCertField(data, 'integrationTime', 'integration_time'),
        submitCount: this.pickCertField(data, 'submitCount', 'submit_count'),
        created: this.pickCertField(data, 'created'),
        updated: this.pickCertField(data, 'updated')
      }
      const status = this.pickCertField(data, 'auditStatus', 'audit_status')
      this.certAuditStatus = status === '' ? 0 : Number(status)
      this.certLicenseImages = this.parseCertImages(this.pickCertField(data, 'licenseImages', 'license_images'))
      this.certWorkImages = this.parseCertImages(this.pickCertField(data, 'workImages', 'work_images'))
      const frontList = this.parseCertImages(this.pickCertField(data, 'idCardFront', 'id_card_front'))
      const backList = this.parseCertImages(this.pickCertField(data, 'idCardBack', 'id_card_back'))
      this.certIdCardFront = frontList[0] || ''
      this.certIdCardBack = backList[0] || ''
      this.certDialogVisible = true
    },
    async approvedCert() {
      const { data: res } = await this.$http.post(`/admin/medicalCert/approved?userId=${this.certUserId}`)
      if (res.code == 200) {
        this.$message.success('审核成功')
        this.certDialogVisible = false
        this.getUserList()
      } else {
        this.$message.error(res.msg || '审核失败')
      }
    },
    rejectedCert() {
      this.certReason = ''
      this.certRejectVisible = true
    },
    async certRejectSubmit() {
      if (!this.certReason || !this.certReason.trim()) {
        this.$message.error('请输入拒绝原因')
        return
      }
      const { data: res } = await this.$http.post(`/admin/medicalCert/rejected?userId=${this.certUserId}&reason=${encodeURIComponent(this.certReason)}`)
      if (res.code == 200) {
        this.$message.success('审核不通过成功')
        this.certRejectVisible = false
        this.certDialogVisible = false
        this.getUserList()
      } else {
        this.$message.error(res.msg || '审核不通过失败')
      }
    },
    downloadAndOpenPdf(pdfPath) {
      if (!pdfPath) {
        this.$message.error('PDF 路径为空')
        return
      }
      const url = this.$url + pdfPath
      fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
          const blobUrl = window.URL.createObjectURL(blob)
          window.open(blobUrl, '_blank')
          setTimeout(() => {
            window.URL.revokeObjectURL(blobUrl)
          }, 1000)
        })
        .catch(() => {
          this.$message.error('PDF 加载失败')
        })
    },
    getImgList(index) {
      // 预览时将当前点击的图片排到第一位
      const list = [...this.imageList]
      const item = list.splice(index, 1)[0]
      list.unshift(item)
      return list
    },
    //提交积分
     async fundsSubmit(){
      const { data: res } = await this.$http.post(`/admin/physicalReport/approvedUserReport?id=${this.adminId}&score=${this.fundsSize}`)  
      console.log(res)
      if(res.code == 200){
        this.$message.success('审核成功')
        this.getUserList()
      }else{
        this.$message.error('审核失败')
      }
      this.fundsSize = ''
      this.funds=false
     },
    async approved(){
      this.reportDialogVisible = false
      this.funds=true
      
    },
    rejected(){
      this.outerVisible = true
      console.log(this.outerVisible)
      this.reportDialogVisible = false
    },
    async reportSubmit(){
      this.outerVisible = false
      const { data: res } = await this.$http.post(`/admin/physicalReport/rejectedUserReport?id=${this.adminId}&reason=${this.reason}`)  
      
      if(res.code == 200){
        this.$message.success('审核不通过成功')
        this.getUserList()
      }else{
        this.$message.error('审核不通过失败')
      }
    },
     formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      
      const year = date.getFullYear();
      // 月份是从0开始的，所以要+1；padStart(2, '0')用于补零
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 获取用户列表
    async getUserList() {
      console.log(this.queryParams)
      const { data: res } = await this.$http.get('/admin/user/getUserList', { params: this.queryParams })
      this.userList = res.data.list
      this.srcList = []
      res.data.list.forEach((e) => {
        if (e.avatar != null && e.avatar != '') {
          this.srcList.push(this.$url + e.avatar)
        }
      })
      this.total = res.data.total
    },
    //
    sex(row) {
      if (row.gender == 0) {
        return '男'
      } else if (row.gender == 1) {
        return '女'
      }
    },
    // 修改状态
    async updateBrandStatus(row) {
      const { data: res } = await this.$http.post(`/admin/user/updateUserStatus?id=${row.id}&status=${row.status}`)
      this.getUserList()
    },
    async goto(phone) {
      this.$router.push({ path: 'userInfo', query: { phone: phone, pageNum: this.queryParams.pageNum, type: 1 } })
    }
  }
}
</script>
<style lang='scss' scoped>
  .report-footer{
    margin-top: 50px;
    // border:#c21111 1px solid;
  }
  .images_title{
    color: #171717;
    font-size: 20px;
    display: block;
    margin-bottom: 20px;
    margin-top: 40px;
  }
  .result{
    font-size: 20px;
    margin-top:20px;
  }
  .iconpdf{
    color: #aa4d4d;
    font-size: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
    // margin-right: 5px;
  }
  .status_item{
    margin-top: 10px;
  }
  .reason{
    color: #c21111;
    margin-top: 5px;
  }
  .reject_reason{
    margin-top: 20px;
  }
  .cert-desc{
    margin-top: 20px;
  }
  .cert-id-label{
    font-size: 14px;
    color: #606266;
    margin-bottom: 8px;
  }
  .cert-preview-image{
    cursor: pointer;
  }
  .cert-image-error{
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f7fa;
    color: #909399;
    font-size: 12px;
    text-align: center;
  }
  .cert-img-preview-wrap{
    text-align: center;
  }
  .cert-img-preview{
    max-width: 100%;
    max-height: 70vh;
  }
  .cert-img-preview-nav{
    margin-top: 16px;
  }
</style>